// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/plan_auto_resubmit_setting_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { PlanAutoResubmitSettingService } from "./plan_auto_resubmit_setting_service_pb";

/**
 * GetPlanAutoResubmitAvailability returns whether the automatic plan
 * resubmission settings are available (the same for every organization). The
 * plan list shows the settings entry only when feature_enabled is true.
 *
 * @generated from rpc bffuser.v1.PlanAutoResubmitSettingService.GetPlanAutoResubmitAvailability
 */
export const getPlanAutoResubmitAvailability = PlanAutoResubmitSettingService.method.getPlanAutoResubmitAvailability;

/**
 * ListProcurementPlanAutoResubmitSettings returns all 20 需要調達計画
 * setting units (10 areas × 2 区分) in AreaCode order, then 需要BG before
 * 自己託送BG. Units with no saved row are returned as enabled=false
 * without updated_at (AC-PAR-001 既定はオフ). feature_enabled=false and no
 * settings when the settings are not available.
 *
 * @generated from rpc bffuser.v1.PlanAutoResubmitSettingService.ListProcurementPlanAutoResubmitSettings
 */
export const listProcurementPlanAutoResubmitSettings = PlanAutoResubmitSettingService.method.listProcurementPlanAutoResubmitSettings;

/**
 * UpdateProcurementPlanAutoResubmitSetting saves the on/off of one setting
 * unit (AC-PAR-002 / 011). When another user changed the unit first
 * (expected_updated_at does not match), the server returns ABORTED and
 * keeps the stored value. FAILED_PRECONDITION (nothing is written) when the
 * settings are not available.
 *
 * @generated from rpc bffuser.v1.PlanAutoResubmitSettingService.UpdateProcurementPlanAutoResubmitSetting
 */
export const updateProcurementPlanAutoResubmitSetting = PlanAutoResubmitSettingService.method.updateProcurementPlanAutoResubmitSetting;
